import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isMoveFolderRequestFailure() {
      return getState().isFailure;
    },
    isMoveFolderRequestPending() {
      return getState().isPending;
    },
    isMoveFolderRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
